import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { capitalize } from 'lodash';

import FormLabel from 'components/FormLabel';
import Icons from 'assets/images/Icons';

type IInputPassword = {
  className?: string
  disabled?: boolean
  match?: string | null
  name: string
  placeholder?: string
  title?: string
}

import './input-password.scss';
import classNames from 'classnames';

const InputPassword = ({
  className,
  disabled = false,
  match = null,
  name,
  placeholder,
  title,
}: IInputPassword) => {
  const { register, formState: { errors }, getValues } = useFormContext();
  const [inputType, setInputType] = useState<'text'|'password'>('password');
  const icon = {
    password: 'Hide',
    text: 'Show',
  };

  const passwordValidation = {
    minLength: {
      message: 'Password must be at least 8 characters long',
      value: 8,
    },
    pattern: {
      message: 'Password must contain at least one letter',
      value: /[a-zA-Z]/,
    },
    required: 'Password can\'t be blank',
    validate: match
      ? (
        value:string,
      ) => value === getValues(match!) || 'Password values must match'
      : () => true,
  };

  const toggleInputType = () => {
    const inputTypes = ['text', 'password'];

    setInputType((old) => inputTypes.filter((type) => type !== old)[0] as 'text'|'password');
  };

  return (
    <FormLabel field={name} name={title ?? capitalize(name)} className={className}>
      <input
        type={inputType}
        placeholder={placeholder ?? capitalize(name)}
        {...register(name, { ...passwordValidation })}
        disabled={disabled}
      />
      <button type='button' className={classNames({
        toggleInputPassword: true,
        withErrors: !!errors[name],
      })} onClick={toggleInputType}>
        <Icons name={icon[inputType] as 'Hide'| 'Show'} />
      </button>
    </FormLabel>
  );
};

export default InputPassword;